import AppStore from './AppStore';
import UserStore from './UserStore';
import HistoryStore from './HistoryStore';
import DriveStore from './DriveStore';
import PrivateStore from './PrivateDriveStore';
import TaskStore from './TaskStore';
import AccountStore from './AccountStore';
import DocStore from './DocStore';
import CollaborationStore from './CollaborationStore';
import Viewer from './Viewer';
import TeamsAppStore from './TeamsAppStore';
import PluginStore from './PluginStore'
import IDoxStore from './IDoxStore'
import FoxitSignStore from './FoxitSignStore';
import EsignCnStore from './EsignCnStore';
import NetDriverStore from  './NetDriverStore';
import StorageAppStore from  './StorageAppStore';
import PaperCheckStore from './PaperCheckStore';

// 新增 登錄方式
import loginNew from './fwStore/loginStore.new'
import userNew from './fwStore/userStore.new'
import docs from './fwStore/docs'
import saveFileNew from './fwStore/saveFile.new'
import addCoverPage from './fwStore/addCoverPage'
import pageOnload from './fwStore/pageOnload'
import openUrlFile from './fwStore/openUrlFile'
import share from './fwStore/share';
import shareCollaboration from './fwStore/shareCollaboration';
import common from './fwStore/common'
import convert from './fwStore/convert'
import office from './fwStore/office'
// import advertStore from './fwStore/advert'
import fwAdver from './fwStore/fwAdver'
import homePage from './fwStore/homePage'
// 新增 云编辑h5
import fwMobileView from './fwMobileStore/fwMobileView'
import fwMobileTool from './fwMobileStore/fwMobileTool';
import fwMobileHome from './fwMobileStore/fwMobileHome';


export const store = {
  isLoading: true,
  appStore: new AppStore(),
  accountStore: new AccountStore(),
  userStore: new UserStore(),
  historyStore: new HistoryStore(),
  driveStore: new DriveStore(),
  privateDriveStore: new PrivateStore(),
  taskStore: new TaskStore(),
  docStore: new DocStore(),
  collaborationStore: new CollaborationStore(),
  viewer: new Viewer(),
  teamsAppStore: new TeamsAppStore(),
  pluginStore: new PluginStore(),
  //serviceConfigStore: new ServiceConfigStore(),
  iDoxStore: new IDoxStore(),
  foxitSignStore: new FoxitSignStore(),
  esignCnStore: new EsignCnStore(),
  netDriverStore: new NetDriverStore(),
  storageAppStore: new StorageAppStore(),
  paperCheckStore: new PaperCheckStore(),
  
  // 新增的登录校验
  loginNewStore: new loginNew(),
  userNewStore: new userNew(),
  common: new common(),
  convert: new convert(),
  office: new office(),
  saveFileNewStore: new saveFileNew(),
  addCoverPageStore: new addCoverPage(),
  pageOnloadStore: new pageOnload(),
  openUrlFileStore: new openUrlFile(),
  docsStore: new docs(),
  shareStore: new share(),
  shareCollaborationStore: new shareCollaboration(),
  advertStore: new fwAdver(),
  homePageStore: new homePage(),
  // h5端store
  fwMobileViewStore: new fwMobileView(),
  fwMobileToolStore: new fwMobileTool(),
  fwMobileHomeStore: new fwMobileHome(),
};

export default store;
